import { apiClient } from '~/api/client';
import { CompanyORLoanOfficerJSONAPI } from '~/sections/dashboard/types';

type IndexParams = {
  period: number;
  value?: string[];
  limit?: number;
  page?: number;
};

type IndexResponse = {
  transactions_data: {
    data: CompanyORLoanOfficerJSONAPI[];
    meta: {
      total_count?: number;
    };
  };
};

export const index = async (params: IndexParams) =>
  apiClient.get<IndexResponse>(`/dashboard/loan_transactions/companies`, { params });
